<aig-modal class="aig-modal-client" position="center" customMaxWidth="600px" customWidth="600px">
    <div class="u-p-8 u-pb-3" body>
      <div class="p-flexcc u-dir-col">
        <img src="./assets/images/logos/logo.svg" class="u-mb-3" />
        <p class="u-fs-18 u-fw-400 u-color-black u-mt-def p-flexcc">
          ¿Eres el titular de la póliza?
        </p>
      </div>
    </div>
    <div class="u-p-8 u-pt-def u-gap-8 p-flexcc" buttons>
        <button class="e-btn--secondary u-size-per-100 p-flexcc" (click)="clickHide()">
          <p class="u-fs-16 u-fw-600">No</p>
        </button>
        <button class="e-btn--primary u-size-per-100 p-flexcc" (click)="OpenNewClaim()">
          <p class="u-fs-16 u-fw-600">Si, soy el titular</p>
        </button>
      </div>
  </aig-modal>
  